import { memo } from 'react';
import Icon from '../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';

interface IProps {
  types: Icons[];
}

interface ITypeProps {
  iconName: Icons;
  index: number;
}

const OrderType: React.FC<ITypeProps> = memo((props: ITypeProps): JSX.Element => {
  return <Icon name={props.iconName} size={14} className={props.index ? 'ml-3' : undefined} />;
});

const OrderTypes: React.FC<IProps> = memo((props: IProps): JSX.Element => {
  return <>{props.types.length ? props.types.map((type, index) => <OrderType key={type} iconName={type} index={index} />) : '-'}</>;
});

export default OrderTypes;
